<template>
    <div class="text-lg font-semibold text-dark pb-2">
        <slot />
    </div>
</template>
